import React, { useEffect, useReducer, useState } from 'react';
import UserDefaultAvatar from "assets/img/user.svg";
import Scrollbar from "react-scrollbars-custom";
import { useSelector } from "react-redux";
import LazyLoadImage from "components/LazyLoadImage";
import classNames from 'classnames';
import { ReactComponent as PlayIcon } from "assets/img/icons/play-fill.svg";
import MediaPreview from 'components/MediaPreview/MediaPreview';
import { ReactComponent as AudioWaveIcon } from "assets/img/icons/audio-wave.svg";
import { ReactComponent as SpeakerIcon } from "assets/img/icons/speaker.svg";
import { ReactComponent as CircleIcon } from "assets/img/icons/circle-dot-svgrepo-com.svg";
import { ReactComponent as CheckInIcon } from "assets/img/icons/check-in.svg";
import { Modal } from "react-responsive-modal";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import 'assets/scss/partials/ai-assistant.scss';
import Loader from 'components/Loader';
import Button from "components/CustomButton";
import AIService from 'services/AIService';
import { useGlobalContext } from "store/contexts/globalContext";
import { useTeamContext } from "store/contexts/teamContext";
import AIAvatarResponse from './AI-Avatar-Response';
import { aiAvatarState, aiAvatarReducer, SetAIAvatarFunction } from "store/reducers/aiAvatarReducer";
import { useAIContext } from "store/contexts/aiContext";
import SelectionModal from './SelectionModal';

function AIAvatar() {
	const { avatars, sounds } = useSelector(
		(state) => state.timelineReducer
	);
	const { aiOption, displayAIModal, formik, sendToS3, setAiOption, setDisplayAI } = useAIContext();
	const { text, attachment } = formik.values;
	const [{ selectAvatar, selectSound, showModal, loading, error, intervalId }, dispatch] = useReducer(aiAvatarReducer, aiAvatarState);
	const { setAvatar, setSound, setModal, setLoading, setAvatarError, setInterValId } = new SetAIAvatarFunction(dispatch);
	const [displaySelectionModal, setDisplaySelectionModal] = useState(false);
	const { team } = useTeamContext();
	const { aiAvatarData, setAiAvatar } = useGlobalContext();

	useEffect(() => {
		if (displayAIModal && aiOption === 1) {


			if (text && attachment) {
				setDisplaySelectionModal(true);
			}
			setModal(true);
		}

		//eslint-disable-next-line
	}, [aiOption, displayAIModal])

	useEffect(() => {
		if (Object.keys(aiAvatarData.data).length !== 0) {
			formik.setFieldValue("avatarMedia", aiAvatarData.data.media);
			if (intervalId) {
				clearInterval(intervalId);
			}
		}

		//eslint-disable-next-line
	}, [aiAvatarData])

	const rejectAvatar = () => {
		setAiAvatar({
			id: null,
			data: {}
		});
		
		formik.setFieldValue("avatarMedia", "");
		setModal(false);
		setLoading(false);
		setAvatar(null);
		setSound(null);
		setDisplayAI(false);
		setDisplaySelectionModal(false);
	}

	const handleSelectAvatar = (avatar) => {
		setAvatar(avatar);
	}

	const handleSelectSound = (sound) => {
		setSound(sound);
	}

	const clearAttachment = () => {
		formik.setFieldValue("attachment", null);
	}

	const hide = () => {
		setModal(false);
		rejectAvatar();
		setDisplayAI(false);
		setDisplaySelectionModal(false);
	}

	const generateAvatar = async () => {
		if (!selectAvatar || !selectSound) {
			setAvatarError("Please select avatar and sound from the list.");
			setTimeout((_) => {
				setAvatarError(null);
			}, 2000);
			return
		}

		try {
			setAiOption(0);
			setLoading(true);
			const response = await AIService.generateAvatar({
				text: text,
				avatar_id: selectAvatar.id,
				voice_id: selectSound.id,
				team_id: team.id
			});
			setAiAvatar({ id: response.data.data.data.id, data: {} });
			checkGeneraterAvatarStats(response.data.data.id);

		} catch (e) {
			console.log(e);
			setLoading(false);
		}
	}

	const checkGeneraterAvatarStats = (id) => {
		const intervalId = setInterval(async () => {
			var response = await AIService.getGeneratedAvatar(id);

			const { status_id, processing_id, result_url } = response.data.data;
			if (status_id) {
				setAiAvatar({ id: processing_id, data: { ...response.data.data, talkingface_url: result_url } });
				clearInterval(intervalId);
			}
		}, 10000);
		setInterValId(intervalId);
	}

	const continueToGenerate = (value) => {
		setDisplaySelectionModal(false);
		formik.setFieldValue("text", value);
	}

	const keepValue = async () => {
		setModal(false);
		setAiAvatar({
			id: null,
			data: {}
		});
		
		setModal(false);
		setLoading(false);
		setAvatar(null);
		setSound(null);
		setDisplayAI(false);
		setDisplaySelectionModal(false);
		await formik.handleSubmit();
	}

	return (
		<>
			<Modal
				open={showModal}
				onClose={() => hide()}
				closeOnOverlayClick={false}
				closeOnEsc={false}
				showCloseIcon={false}
				center={true}
				classNames={{ modal: "aiModal" }}
			>
				{Object.keys(aiAvatarData.data).length !== 0 && (
					<AIAvatarResponse
						url={aiAvatarData.data.talkingface_url}
						keepValue={keepValue}
						rejectAvatar={rejectAvatar}
					/>
				)}
				{Object.keys(aiAvatarData.data).length === 0 && (
					<>
						<div className='ai-modal-content'>
							<div>
								<h5>ReTeam Avatar</h5>
								<CloseIcon onClick={hide} className={classNames({
									"close-icon": true,
									"disabled-avatar-icon": loading
								})} />
							</div>
							{displaySelectionModal && (
								<SelectionModal sendToS3={sendToS3} clearAttachment={clearAttachment} continueToGenerate={continueToGenerate} attachment={attachment} />
							)}
							{!displaySelectionModal && (
								<div>
									<span className='avatar-choose'>Select Image </span>
									<Scrollbar style={{ height: '100px', marginTop: "10px" }}>
										<div className='ai-avatars-root-modal'>
											{avatars?.map((avatar) =>
												<div className='avatar-root' key={avatar.id} onClick={() => handleSelectAvatar(avatar)}>
													<LazyLoadImage
														image={avatar.media ?? UserDefaultAvatar}
														alt={avatar.name}
														imageClassName={classNames({
															"ai-avatar-img": true,
															selectedAvatar: selectAvatar?.id === avatar.id ? true : false,
														})}
													/>
													<span>{avatar.name}</span>
												</div>
											)}
										</div>
									</Scrollbar>
									<div className="avatar-root-voice">
										<span className='avatar-choose'>Select Voice:</span>
										<Scrollbar style={{ height: '300px', marginTop: "15px" }}>
											<div className='avatar-sound-root'>
												{sounds?.map((sound, index) => (
													<div key={index} className='avatar-sound-content'>
														<div className='avatar-sound '>
															<span className='avatar-sound-name'>{sound?.name}</span>
															<span className='avatar-sound-img'>
																<SpeakerIcon className='wave-img' />
																<AudioWaveIcon className='wave-img' />
																<AudioWaveIcon className='wave-img' />
																<AudioWaveIcon className='wave-img' />
																<AudioWaveIcon className='wave-img' />
															</span>
															<MediaPreview
																attachment={sound?.media}
																type={"audio"}
															>
																<PlayIcon className='avatar-sound-play' />
															</MediaPreview>
														</div>
														{selectSound?.id === sound.id && (
															<CheckInIcon onClick={() => handleSelectSound(null)} className='avatar-circle-img' />
														)}
														{selectSound?.id !== sound.id && (
															<CircleIcon onClick={() => handleSelectSound(sound)} className='avatar-circle-img' />
														)}
													</div>
												))}
											</div>
										</Scrollbar>
									</div>
								</div>
							)}
						</div>
						{error && <div className='error-msg'>{error}</div>}
						{!displaySelectionModal && (
							<div className='ai-modal-footer'>
								<Button
									disabled={loading}
									onClick={generateAvatar}
								>
									{!loading ? "Generate Avatar" : <Loader width={25} height={25} />}
								</Button>
							</div>
						)}
					</>
				)}
			</Modal>
		</>
	)
}

export default AIAvatar;